import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";
import "../../../css/plantillas.css";
import RatingIcon from "../Plantillas/Respuestas/valoracionestrellas/valoracion";

const returnMatrix = (opciones) => {
  var temp = [];
  if (opciones.length > 1) {
    for (
      var i = parseInt(opciones[0].valor);
      i < parseInt(opciones[1].valor) + 1;
      i++
    ) {
      temp = [...temp, i];
      // console.log(temp);
    }
  }
  return temp;
};

const CampoPreguntaEncuesta = (props) => {
  let matriz = returnMatrix(props.pregunta.list_Plantilla_Opciones);
  const [selectedItem, setSelectedItem] = useState([]);

  //Inicio calificación estrella
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const onMouseEnter = (index) => {
    setHoverRating(index);
  };
  const onMouseLeave = () => {
    setHoverRating(0);
  };
  const onSaveRating = (index, idOpcion) => {
    setRating(index);
    let _data = props.respuestasF;
    _data.respuestas[props.index].respuesta = index;
    _data.respuestas[props.index].opcion = [parseInt(idOpcion)];
    props.setRespuestasF(_data);
  };
  //Fin calificación estrella

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    let _respuesta = props.pregunta.list_Plantilla_Opciones.find(
      (op) => op.id === parseInt(checkValue)
    );
    let req = [];
    if (checked) {
      req = [
        ...selectedItem,
        { valor: _respuesta.valor, idOpcion: parseInt(checkValue) },
      ];
      setSelectedItem(req);
    } else {
      req = selectedItem.filter((e) => e.idOpcion !== checkValue);
      setSelectedItem(req);
    }
    let _data = props.respuestasF;
    _data.respuestas[props.index].respuesta = req[0].valor;
    _data.respuestas[props.index].opcion = [];
    req.map((item) => {
      _data.respuestas[props.index].opcion.push(item.idOpcion);
    });
    props.setRespuestasF(_data);
  };

  return (
    <Form.Group
      className="shadow-sm mb-5 bg-white rounded"
      style={{ border: "0.1px solid #ced4da" }}
    >
      <div className="estiloFondo">
        <div
          className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center"
          style={{ height: "2rem" }}
        >
          <Button size="sm" className="btn rounded-circle" disabled></Button>
        </div>
      </div>
      <div className="p-3">
        <Form>
          <Row>
            <Form.Group
              as={Col}
              className="mb-3"
              sm="12"
              md="12"
              lg="12"
              xl="12"
            >
              <Col
                className="p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                style={{ borderBottom: "0.1px solid #ced4da" }}
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <h6 className="m-0">
                  {props.pregunta ? props.pregunta.pregunta : null}
                </h6>
              </Col>
            </Form.Group>
          </Row>
        </Form>
        <Row>
          <Form.Group as={Col} className="mb-3">
            <>
              {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                "Matriz/escala valoración".toLowerCase() && (
                <Row className="d-flex flex-wrap justify-content-center align-items-center text-justify">
                  {matriz.map((item, index) => (
                    <>
                      <Col sm="1" md="1" lg="1" xl="1">
                        <Form.Group
                          as={Col}
                          sm="1"
                          md="1"
                          lg="1"
                          xl="1"
                          className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                        >
                          <Col
                            className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {parseInt(index + 1)}
                          </Col>
                          <Form.Check
                            className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                            type="radio"
                            required
                            name={`escala ` + props.pregunta.pregunta}
                            onChange={() => {
                              let _data = props.respuestasF;
                              _data.respuestas[
                                props.index
                              ].respuesta = `${item}`;
                              _data.respuestas[props.index].opcion = [
                                props.pregunta.list_Plantilla_Opciones[0].id,
                              ];
                              props.setRespuestasF(_data);
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  ))}
                </Row>
              )}
              {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                "MENU DESPLEGABLE".toLowerCase() && (
                <Form.Group
                  as={Col}
                  className="mb-3"
                  sm="12"
                  md="8"
                  lg="8"
                  xl="8"
                >
                  <Form.Control
                    as="select"
                    id="categoria"
                    required
                    name={`desplegable ` + props.pregunta.pregunta}
                    className="rounded-pill"
                    placeholder="Categoría"
                    onChange={(e) => {
                      const index = e.currentTarget.selectedIndex;
                      const valorPregunta = e.target.options[index].text;
                      let _data = props.respuestasF;
                      _data.respuestas[props.index].respuesta = valorPregunta;
                      _data.respuestas[props.index].opcion = [
                        parseInt(e.currentTarget.value),
                      ];
                      props.setRespuestasF(_data);
                    }}
                  >
                    <option value="">Seleccione una opción</option>
                    {props.pregunta.list_Plantilla_Opciones
                      .sort((a, b) => {
                        if (a.posicion !== null && b.posicion !== null) {
                          if (parseInt(a.posicion) === parseInt(b.posicion)) {
                            return 0;
                          }
                          if (parseInt(a.posicion) < parseInt(b.posicion)) {
                            return -1;
                          }
                        }
                        return 1;
                      })
                      .map((item, index) => (
                        <>
                          <option key={item.id} value={item.id}>
                            {item.respuesta ? item.respuesta.toUpperCase() : ""}
                          </option>
                        </>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo Obligatorio
                  </Form.Control.Feedback>
                </Form.Group>
              )}
              <Row>
                <Form.Group
                  as={Col}
                  className="pl-3 pr-3"
                  controlId={
                    `opcion multiple ${props.index}` + props.pregunta.pregunta
                  }
                >
                  <Row>
                    {props.pregunta.list_Plantilla_Opciones
                      .sort((a, b) => {
                        if (a.posicion !== null && b.posicion !== null) {
                          if (
                            parseInt(a.posicion) === parseInt(b.posicion) &&
                            parseInt(a.id) > parseInt(b.id)
                          ) {
                            return 1;
                          }

                          if (
                            parseInt(a.posicion) === parseInt(b.posicion) &&
                            parseInt(a.id) < parseInt(b.id)
                          ) {
                            return -1;
                          }

                          if (parseInt(a.posicion) < parseInt(b.posicion)) {
                            return -1;
                          }

                          if (parseInt(a.posicion) > parseInt(b.posicion)) {
                            return 1;
                          }
                        }
                        if (parseInt(a.id) > parseInt(b.id)) {
                          return 1;
                        } else {
                          return -1;
                        }
                      })
                      .map((item, index) => {
                        return (
                          <Col sm="12" md="12" lg="12" xl="12" key={item.id}>
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "OPCIÓN MÚLTIPLE".toLowerCase() && (
                              <Form.Group>
                                <Row className="pl-3 pr-3 mb-3">
                                  <Col xs="auto">
                                    <Form.Check class="form-inline justify-content-center">
                                      <Form.Check.Input
                                        type="radio"
                                        name={
                                          `opcion multiple ${props.index}` +
                                          props.pregunta.pregunta
                                        }
                                        onChange={() => {
                                          let _data = props.respuestasF;
                                          _data.respuestas[
                                            props.index
                                          ].respuesta = "";
                                          _data.respuestas[props.index].opcion =
                                            [parseInt(item.id)];
                                          props.setRespuestasF(_data);
                                        }}
                                        required
                                      />
                                    </Form.Check>
                                  </Col>
                                  <Col
                                    sm="10"
                                    md="10"
                                    lg="10"
                                    xl="10"
                                    style={{
                                      borderBottom: "0.1px solid #ced4da",
                                      padding: "0.5rem",
                                    }}
                                    className="shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                                  >
                                    <Col
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {item.respuesta}
                                    </Col>
                                  </Col>
                                </Row>
                              </Form.Group>
                            )}
                          </Col>
                        );
                      })}
                  </Row>
                  <Form.Control.Feedback type="invalid">
                    **Campo <br /> Obligatorio
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} className="pl-3 pr-3">
                  <Row>
                    {props.pregunta.list_Plantilla_Opciones
                      .sort((a, b) => {
                        if (a.posicion !== null && b.posicion !== null) {
                          if (
                            parseInt(a.posicion) === parseInt(b.posicion) &&
                            parseInt(a.id) > parseInt(b.id)
                          ) {
                            return 1;
                          }

                          if (
                            parseInt(a.posicion) === parseInt(b.posicion) &&
                            parseInt(a.id) < parseInt(b.id)
                          ) {
                            return -1;
                          }

                          if (parseInt(a.posicion) < parseInt(b.posicion)) {
                            return -1;
                          }

                          if (parseInt(a.posicion) > parseInt(b.posicion)) {
                            return 1;
                          }
                        }
                        if (parseInt(a.id) > parseInt(b.id)) {
                          return 1;
                        } else {
                          return -1;
                        }
                      })
                      .map((item, index) => {
                        return (
                          <Col sm="12" md="12" lg="12" xl="12" key={item.id}>
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "CASILLAS DE VERIFICACIÓN".toLowerCase() && (
                              <Row className="pl-3 pr-3 mb-3">
                                <Col>
                                  <Form.Check class="form-inline justify-content-center">
                                    <Form.Check.Input
                                      type="checkbox"
                                      name={
                                        `opcion casillas ${props.index}` +
                                        props.pregunta.pregunta
                                      }
                                      className="d-flex flex-wrap justify-content-center align-items-center"
                                      onChange={handleCheckbox}
                                      // value={item.respuesta}
                                      value={item.id}
                                      // required
                                    />
                                    <Form.Check.Label
                                      className="bg-white shadow-sm rounded d-flex justify-content-between align-items-center pl-3"
                                      style={{
                                        borderBottom: "0.1px solid #ced4da",
                                      }}
                                    >
                                      {item.respuesta}
                                    </Form.Check.Label>
                                    <Form.Control.Feedback type="invalid">
                                      ** Campo Obligatorio
                                    </Form.Control.Feedback>
                                  </Form.Check>
                                </Col>
                              </Row>
                            )}
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "CAMPO TEXTO SIMPLE".toLowerCase() && (
                              <Form.Group>
                                <Row className="m-3">
                                  <Col
                                    className="p-0 mb-3 d-flex flex-wrap justify-content-center align-items-start"
                                    xs="12"
                                    sm="12"
                                    md="12"
                                    lg="12"
                                    xl="12"
                                  >
                                    <Form.Control
                                      name={
                                        `respuesta breve ${props.index}` +
                                        props.pregunta.pregunta
                                      }
                                      className="rounded-pill "
                                      required
                                      type="text"
                                      onChange={(e) => {
                                        let _data = props.respuestasF;
                                        _data.respuestas[
                                          props.index
                                        ].respuesta = e.currentTarget.value;
                                        _data.respuestas[props.index].opcion = [
                                          parseInt(
                                            props.pregunta
                                              .list_Plantilla_Opciones[0].id
                                          ),
                                        ];
                                        props.setRespuestasF(_data);
                                      }}
                                      pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                                      placeholder="Texto de respuesta simple"
                                    ></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                      **Campo Obligatorio
                                    </Form.Control.Feedback>
                                  </Col>
                                </Row>
                              </Form.Group>
                            )}
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "CAMPO TEXTO LIBRE".toLowerCase() && (
                              <Form.Group>
                                <Row>
                                  <Col
                                    className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
                                    sm="12"
                                    md="12"
                                    lg="12"
                                    xl="12"
                                  >
                                    <Form.Control
                                      name={
                                        `texto libre ${props.index}` +
                                        props.pregunta.pregunta
                                      }
                                      required
                                      as="textArea"
                                      onChange={(e) => {
                                        let _data = props.respuestasF;
                                        _data.respuestas[
                                          props.index
                                        ].respuesta = e.currentTarget.value;
                                        _data.respuestas[props.index].opcion = [
                                          parseInt(
                                            props.pregunta
                                              .list_Plantilla_Opciones[0].id
                                          ),
                                        ];
                                        props.setRespuestasF(_data);
                                      }}
                                      pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                                      placeholder="Texto de respuesta larga"
                                    ></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                      **Campo Obligatorio
                                    </Form.Control.Feedback>
                                  </Col>
                                </Row>
                              </Form.Group>
                            )}
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "Valoración por estrellas".toLowerCase() && (
                              <Row className="box d-flex ml-3">
                                {[1, 2, 3, 4, 5].map((index) => {
                                  return (
                                    <RatingIcon
                                      index={index}
                                      rating={rating}
                                      // onChange={() => console.log(item.id)}
                                      hoverRating={hoverRating}
                                      onMouseEnter={onMouseEnter}
                                      onMouseLeave={onMouseLeave}
                                      onSaveRating={() =>
                                        onSaveRating(index, item.id)
                                      }
                                    />
                                  );
                                })}
                                <Form.Control.Feedback type="invalid">
                                  **Campo Obligatorio
                                </Form.Control.Feedback>
                              </Row>
                            )}
                            {props.pregunta.list_tipo[0].nombre.toLowerCase() ===
                              "FECHA/Hora".toLowerCase() && (
                              <Form.Group>
                                <Row>
                                  <Form.Group
                                    as={Col}
                                    className="mb-3"
                                    sm="12"
                                    md="8"
                                    lg="8"
                                    xl="8"
                                  >
                                    <Row>
                                      <Col
                                        xs="12"
                                        sm="12"
                                        md="12"
                                        lg="12"
                                        xl="12"
                                      >
                                        <Form.Control
                                          name="fecha"
                                          className="rounded-pill"
                                          required
                                          type="date"
                                          onChange={(e) => {
                                            let _data = props.respuestasF;
                                            _data.respuestas[
                                              props.index
                                            ].respuesta = e.currentTarget.value;
                                            _data.respuestas[
                                              props.index
                                            ].opcion = [
                                              parseInt(
                                                props.pregunta
                                                  .list_Plantilla_Opciones[0].id
                                              ),
                                            ];
                                            props.setRespuestasF(_data);
                                          }}
                                          placeholder="Año/Mes/Día   HH:MM"
                                        ></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                          **Campo Obligatorio
                                        </Form.Control.Feedback>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Row>
                              </Form.Group>
                            )}
                          </Col>
                        );
                      })}
                  </Row>
                </Form.Group>
              </Row>
            </>
          </Form.Group>
        </Row>
        <div className="px-2">
          <hr />
        </div>
      </div>
    </Form.Group>
  );
};

export default withRouter(CampoPreguntaEncuesta);
